module.exports = __webpack_public_path__ + "img/subescapular.a2fb2821.png";